import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, ControlLabel, Form, FormGroup } from 'rsuite'
import { requiredFiled } from '../../../utils/ValidatorUtils'
import InputInlineForm from '../../../components/forms/input/InputInlineForm'
import InputForm from '../../../components/forms/input/InputForm'
import CustomAlertMessage from '../../CustomAlertMessage'
import { cloneDeep } from 'lodash-es'

export default function EditFormListWidget({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  getValues,
  clearErrors,
  values,
  objectsValuesName = 'objectsValuesName',
  setLoading = () => {},
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [objects, setObjects] = useState([])
  const [objectsValues, setObjectsValues] = useState(new Map())

  useEffect(() => {
    let datas = values || _schema?.objects || _schema?.values || []
    let objMap = cloneDeep(objectsValues) || new Map()

    setDataToMap(datas, objMap)

    setObjectsValues(objMap)
    // console.log('objectsValuesName : ', objectsValuesName, ' , EditFormListWidget : ', _schema)
    // console.log('objMap : ', objMap)
    setSchema(_schema)
    setObjects(datas)

    setValue(objectsValuesName, datas)
  }, [])

  const setDataToMap = (datas, objMap) => {
    datas?.forEach((e) => {
      objMap.set(e.id, e.result)

      e.moreInputs?.forEach((se) => {
        objMap.set(se.id, se.result)
      })

      if (e.childs) {
        setDataToMap(e.childs, objMap)
      }
    })
  }

  const renderInnerInput = (item, tabRight) => {
    // console.log('data : ', item)
    return (
      <>
        {item.resultType == '3' && (
          <>
            <p />
          </>
        )}
        <ControlLabel>{requiredFiled(item.validators, item.section1)}</ControlLabel>

        {item.resultType && (
          <>
            {item.resultType == '3' ? (
              <>
                <InputForm
                  hideLabel
                  schema={item}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  rows={4}
                  componentClass={'textarea'}
                  // inputWidth={'100%'}
                  // style={{ width: '100%' }}
                  //value={item.result}
                  value={objectsValues?.get(item.id)}
                  onChange={(value) => {
                    let nObj = cloneDeep(objectsValues)
                    nObj.set(item.id, value)

                    setObjectsValues(nObj)

                    setValue(objectsValuesName, nObj)
                  }}
                />
              </>
            ) : (
              <>
                {item.resultType != '0' && (
                  <InputInlineForm
                    schema={item}
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                    isInputNumber={item.resultType == '1'}
                    inputWidth={item.resultType == '1' ? 120 : null}
                    //value={item.result}
                    value={objectsValues?.get(item.id)}
                    onChange={(value) => {
                      let nObj = cloneDeep(objectsValues)
                      nObj.set(item.id, value)

                      setObjectsValues(nObj)

                      setValue(objectsValuesName, nObj)
                    }}
                  />
                )}
              </>
            )}
          </>
        )}

        {item.unit && (
          <ControlLabel style={{ marginLeft: 10, marginRight: 10 }}>{item.unit}</ControlLabel>
        )}

        {item.moreInputs?.map((subItem) => {
          return renderInnerInput(subItem)
        })}
      </>
    )
  }

  const renderInputs = (datas, tabRight) => {
    return (
      <>
        {datas?.map((item, index) => {
          return (
            // <Panel bordered style={{ marginBottom: 10, marginLeft: tabRight ? 20 : undefined }}>
            <Row style={{ marginLeft: tabRight ? 40 : undefined }}>
              <Col xs={24} sm={24} md={24} lg={24}>
                <Form layout="inline">
                  <FormGroup style={{ width: '100%' }}>{renderInnerInput(item, false)}</FormGroup>
                </Form>

                {item.childs && renderInputs(item.childs, true)}
              </Col>
            </Row>
            // </Panel>
          )
        })}
      </>
    )
  }

  return (
    <Panel
      header={props.header}
      collapsible={props.collapsible}
      defaultExpanded={props.defaultExpanded}
      bordered={props.bordered}
      style={{ marginBottom: 20 }}
    >
      <Row style={{ marginTop: -10 }}>
        {schema?.description && (
          <Col style={{ marginBottom: 10 }}>
            <CustomAlertMessage contents={schema.description} />
          </Col>
        )}
      </Row>

      {objects && renderInputs(objects)}
    </Panel>
  )
}
